import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faClose, faGripLines } from '@fortawesome/pro-regular-svg-icons';
import { Button } from '@rocketlane/ui';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { SectionHeadingContainer, SectionTypeHeader } from '../section-styles';

const StyledButton = styled(Button)`
  padding: var(--spacing-01) var(--spacing-03);
  margin-right: var(--spacing-02);
`;

export const SectionHeading = ({
  title,
  onClose,
  showCloseButton = true,
}: {
  title: string;
  onClose: () => void;
  showCloseButton?: boolean;
}) => (
  <SectionHeadingContainer>
    <SectionTypeHeader>
      <FontAwesomeIcon icon={faGripLines} />
      <FormattedMessage id={title} />
    </SectionTypeHeader>
    {showCloseButton && (
      <StyledButton
        variant="ghost"
        size="small"
        onClick={onClose}
        leftIcon={<FontAwesomeIcon icon={faClose} />}
      />
    )}
  </SectionHeadingContainer>
);
